/**
 * VIP customers (founder, 2026-10-25): a label for Defera's highest-spending
 * customers, so the team knows who they are wherever they show up and can
 * look for chances to treat them (complimentary upgrades and the like). Not
 * a rewards tier. The customer sees their own VIP badge too, as recognition
 * only: it promises nothing (no perks, priority or upgrades).
 *
 * Automatic: a customer becomes VIP when their spend reaches the line, and
 * keeps it for VIP_KEEP_MONTHS whatever the spend does, then it is
 * re-checked against the line (migration 191).
 * Spend = the trip totals of their paid-off (completed) and active
 * (confirmed) trips, travel only: cancelled, defaulted and behind trips
 * don't count, a Faye insurance premium doesn't count, and trips paid with
 * Miles don't count (the same rules as status-rewards spend,
 * migration 157 `_qualifying_spend`, without the calendar year).
 * server/vip-customers.js computes it.
 */
export const VIP_SPEND_LINE_DOLLARS = 5000;
export const VIP_KEEP_MONTHS = 12;
export const VIP_LABEL = 'VIP';
export const VIP_SPEND_STATUSES = Object.freeze(['completed', 'confirmed']);
